import React from "react";

import { FormSection } from "components/ratecard/_common";
import { useEditServiceContext, useRateCardContext } from "components/ratecard/contextProviders";
import { getCurrencyByCountry } from "helperFunctions/_common/getCurrencyByCountry";

import EditInline from "./EditInline";
import Preview from "./Preview";

const SpecialProjectsSection = () => {
  const name = ["specialProjects"];
  const { allowEditing } = useEditServiceContext();
  const { activeZone } = useRateCardContext();

  const currency: string = getCurrencyByCountry(activeZone?.facility?.country || "");

  return (
    <FormSection title="Special Projects">
      {allowEditing ? <EditInline name={name} currency={currency} /> : <Preview name={name} currency={currency} />}
    </FormSection>
  );
};

export default SpecialProjectsSection;
